import { EventNames } from './types';

export const EVENT_NAMES: EventNames = {
    GENERIC: 'GA4 - Generic Event',
    VIDEO_CLICK: 'video_click',
};
